import { Stack } from '@mui/joy';
import { createFileRoute, useParams } from '@tanstack/react-router';

import { SideMenuLayout } from '@/components/SideMenuLayout';
import { AssignedExaminationForm } from '@/components/processes/AssignedExaminationForm';
import { ProcessView } from '@/components/processes/ProcessView';
import { UserGuard } from '@/modules/UserGuard';
import { useProcessQuery } from '@/queries/useProcessQuery';
import { useUserQuery } from '@/queries/useUserQuery';

function RouteComponent() {
  const { examinationId } = useParams({ strict: false });

  const { data: process } = useProcessQuery();
  const { data: user } = useUserQuery();

  if (!process) return null;

  if (!UserGuard.isUser(user)) return null;

  const myExamination = process.examinations.find((examination) => examination.id === examinationId);

  return (
    <SideMenuLayout>
      <ProcessView />
      <Stack gap={1} marginTop={2}>
        {myExamination && (
          <AssignedExaminationForm
            examination={myExamination}
            processId={process.id}
            processStatus={process.status}
            onSave={() => {}}
          />
        )}
      </Stack>
    </SideMenuLayout>
  );
}

export const Route = createFileRoute('/_authenticated/_management/vorgaenge/$adminLevelId/$processId/$examinationId')({
  component: RouteComponent,
});
